import type { UpdateIssueUpdateMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateIssueUpdateDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateIssueUpdateInput } from './types';

export const useUpdateIssueUpdate = createMutationHook({
  name: 'updateIssueUpdate',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.issueUpdate.update.mutationOptions({ onSuccess }),
  mapInput: (variables: UpdateIssueUpdateInput): UpdateIssueUpdateInput => ({
    Id: variables.Id,
    ParentIssueId: variables.ParentIssueId,
    Title: variables.Title,
    Description: variables.Description,
    CustomAttributeData: variables.CustomAttributeData ?? null,
    OriginalTimestamp: variables.OriginalTimestamp,
  }),
  // Parity with the Apollo evictField('issue_update') cache eviction
  invalidate: (trpc) => [
    trpc.frontend.issueUpdate.getById.queryKey(),
    trpc.frontend.issueUpdate.register.queryKey(),
    // COI-889: the Issues register's latest-update and update-count columns
    // read `issueUpdateSummary`.
    trpc.frontend.issue.register.queryKey(),
  ],
  mapResponse: (): UpdateIssueUpdateMutation => ({
    update_issue_update: {
      __typename: 'issue_update_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateIssueUpdateDocument,
  graphqlVariables: (variables: UpdateIssueUpdateInput) => ({
    ...variables,
  }),
  validateGraphqlResponse: (data) => {
    if (data.update_issue_update?.affected_rows !== 1) {
      throw new Error(
        'Records not updated. Record may have been updated by another user'
      );
    }
  },
  evictFields: ['issue_update'],
});
